import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Logo, useOutsideClick } from 'quantic'

import navigationItems from './helpers/navigationItems'
import { Wrapper, Nav, NavItem, Section, SubNav, SubNavItem } from './styles'

function Navbar() {
  const navbarRef = useRef()
  const [isHovered, setIsHovered] = useState(false)
  const [activeItem, setActiveItem] = useState(window.location.pathname)
  const [subnavItems, setSubnavItems] = useState([])

  useEffect(() => {
    // Check if one of the children is from current pathname
    const normalizedPathname = window.location.pathname.replace('/', '')
    if (normalizedPathname) {
      const found = navigationItems.find((x) => {
        const childrenNames = x.children.map((y) => String(y.text).toLowerCase())
        if (childrenNames.includes(normalizedPathname)) return x
        return undefined
      })
      if (found) setActiveItem(found.text)
    }
  }, [])

  const isActive = (item) => activeItem.includes(item)

  const { push } = useHistory()

  useOutsideClick(navbarRef, () => setSubnavItems([]))

  return (
    <Wrapper ref={navbarRef} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <Nav isHovered={Boolean(isHovered || subnavItems.length)}>
        <Section hidenOnMobile>
          <Logo onClick={() => push('/')} height="40px" style={{ cursor: 'pointer' }} />
        </Section>
        <Section>
          {navigationItems.map(({ icon: Icon, text, path, children }) => (
            <NavItem
              active={isActive(text)}
              onClick={() => {
                setSubnavItems(children || [])
                if (path) push(path)
              }}
            >
              <Icon />
              <span>{text}</span>
            </NavItem>
          ))}
        </Section>
      </Nav>
      <SubNav active={Boolean(subnavItems.length)}>
        {subnavItems.map((item, index) => (
          <SubNavItem
            key={index}
            onClick={() => {
              push(item.path)
              setSubnavItems([])
            }}
          >
            {item.text}
          </SubNavItem>
        ))}
      </SubNav>
    </Wrapper>
  )
}

export default Navbar
